module.exports = __webpack_public_path__ + "static/media/bg_equipe.49258cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/bg_equipe.png
// module id = 450
// module chunks = 0